import React from 'react';
import axios from 'axios';
import debounce from 'lodash/debounce';

import SearchInputItem from './SearchInputItem.jsx';

class SearchInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            resultsOpen: false,
            loading: false,
            results: []
        }

        this.wrapperRef = React.createRef();

        this.fetchResults = this.fetchResults.bind(this);
        this.toggleResults = this.toggleResults.bind(this);
        this.showResults = this.showResults.bind(this);
        this.handleServiceClick = this.handleServiceClick.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);

        this.delayedFetchResults = debounce(this.fetchResults, 500);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside.bind(this));
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside.bind(this));
    }

    handleClickOutside(event) {
        if (this.wrapperRef && this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
            this.setState({ resultsOpen: false });
        }
    }

    handleServiceClick(item) {
        this.toggleResults();
        this.props.addServiceHandler(item);
    }

    toggleResults() {
        this.setState(prevState => ({
            resultsOpen: !prevState.resultsOpen
        }));
    }

    showResults() {
        this.setState({ resultsOpen: true });
    }

    resultItems() {
        return this.state.results.map((item, index) => {
            return (
                <SearchInputItem key={index} item={item} clickHandler={this.handleServiceClick} />
            )
        });
    }

    normalizeExtras(service) {
        let newExtras = [];
        if (service.upsells) {
            service.upsells.forEach((item) => {
                newExtras.push({
                    title: item.title,
                    price: item.price,
                })
            })
        }
        return newExtras;
    }

    fetchResults(e) {
        this.props.handleSearchInputChange(e.target.value);
        this.setState({
            loading: true
        });
        const that = this;
        axios.get(WPURLS.siteurl + '/wp-json/wp/v2/service?per_page=10&search=' + e.target.value)
            .then(function (response) {
                const results = response.data.map((item) => {
                    return {
                        wpid: item.id,
                        id: item.id,
                        title: item.title.rendered,
                        description: item.content.rendered,
                        price: {
                            value: item.price.value,
                            append: item.price.append,
                            prepend: item.price.prepend
                        },
                        sales_price: {
                            value: item.sales_price && item.sales_price.value || 0,
                            append: item.sales_price && item.sales_price.append || '',
                            prepend: item.sales_price && item.sales_price.prepend || ''
                        },
                        is_on_sale: item.is_on_sale,
                        is_hidden_from_list: item.is_hidden_from_list,
                        duration: {
                            value: item.duration.value,
                            append: item.duration.append
                        },
                        instructions: item.instructions && item.instructions.value,
                        category: item.category,
                        extras: that.normalizeExtras(item)
                    }
                })
                that.setState({ results: results, loading: false })
            })
            .catch(function (error) {
                console.log(error);
                this.setState({
                    loading: false
                });
            });
    }

    handleInputChange(event) {
        event.persist()
        this.delayedFetchResults(event)
    }

    results() {
        if (this.state.resultsOpen) {

            if (this.state.loading) {
                return (
                    <div className="search-input__results">
                        <div className='text-center p-4'>Searching...</div>
                    </div>
                );
            }

            return (
                <div className="search-input__results">
                    { this.resultItems() }
                    {this.state.results.length >= 10 && <div onClick={this.props.openServicesModal} className="search-input__show-more">
                        Show more results
                    </div>}
                </div>
            )
        } else {
            return null;
        }
    }

    render() {
        const errorClass = this.props.error ? "error" : "";
        const classes = "search-input flex items-center " + errorClass;

        return (
            <div className={classes} ref={this.wrapperRef}>
                <i className="search-input__icon fas fa-search"></i>
                <input type="text" placeholder={this.props.placeholder}
                    onClick={this.showResults} onKeyUp={this.handleInputChange} />
                { this.results() }
            </div>
        )
    }
}

export default SearchInput;



// WEBPACK FOOTER //
// ./scripts/components/SearchInput.jsx